import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', display: 'flex', flexDirection: 'column', color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 18, borderBottom: '1px solid rgba(0,0,0,.3)', width: '100%', paddingTop: 20, paddingBottom: 20
    },
    wrapLogin: {
        marginBottom: 12
    },
    login: {
        width: '100%', display: 'flex', justifyContent: 'center'
    },
    wrapCount: {
        display: 'flex', justifyContent: 'center', marginBottom: 20, alignItems: 'center'
    },
    helperCount: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
    },
    count: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
        lineHeight: 0,
        paddingLeft: 16
    },
    wrapDetalization: {
        padding: '0 20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5
    },
    w50: {
        width: '50%'
    },
    wrapHelper: {
        display: 'flex', justifyContent: 'center', marginBottom: 12
    },
    labelHelper: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
        lineHeight: 0,
        display: 'flex', 
        justifyContent: 'center'
    },
    flexBox: {
        display: 'flex', alignItems: 'center'
    },
    helperAmount: {
        color: 'hsla(0,0%,100%,.5)',
        width: '60px',
        fontSize: '14px',
        textAlign: 'right',
        fontFamily: 'PT-sans, sans-serif',
        paddingTop: 2,
    },
    amount: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
        lineHeight: 0,
        paddingLeft: 16
    }
}))

export {
    useStyles
}